import { useState, useEffect, useRef } from 'react';
import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import GeneralInformationTable from './GeneralInformationTable';
import imgLogo from './Portal_PWC.png';
import rightLogo from './right_bar.jpg';
import { useAuth } from 'oidc-react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import validator from "validator";

function NewScrapEvaluation() {
  const auth = useAuth();
  const [configJsonFile, setConfigJsonFile] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.PUBLIC_URL}/Config.json`);
        const data = await response.json();
        setConfigJsonFile(data);
        console.log("Json file read from the Public folder completed:");
      } catch (error) {
        console.error('Error fetching Config JSON file data:', error);
      }
    }
    fetchData();
  }, []);
  useEffect(() => {
    if (configJsonFile != "undefined") {
      //getCSRFToken();
    }
  }, [configJsonFile]);

  const navigate = useNavigate();
  const [apimessage, setAPIMessage] = useState('');
  const [modelPopupshow, setmodelPopupshow] = useState(false);

  const [comments, setComments] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);
  const [VendorCode, setVendorCode] = useState("");
  const [VendorName, setVendorName] = useState("");
  const [VendorEmail, setVendorEmail] = useState("");
  const [ContactName, setContactName] = useState("");
  const [Telephone, setTelephone] = useState("");
  const [QualityManager, setQualityManager] = useState("");
  const [DateValue, setDateValue] = useState(new Date().toISOString().split('T')[0]);
  const [PWC_Representative, setPWC_Representative] = useState("");
  const [rowsData, setRowsData] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [isConfirmChecked, setIsConfirmChecked] = useState(false);
  const csrfToken = useRef(null);
  const cookieToken = useRef(null);
  const [InitiatorEmailAddress, setInitiatorEmailAddress] = useState("");
  const [initiatorEmailError, setInitiatorEmailError] = useState("");
  const [vendorEmailError, setVendorEmailError] = useState("");
  const [VendorEmailCc, setVendorEmailCc] = useState("");
  const [vendorEmailCcError, setVendorEmailCcError] = useState("");
  const [apiErrormessage, setApiErrormessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [SupplierInternalScrap, setSupplierInternalScrap] = useState("");
  const [ValueAdded, setValueAdded] = useState("");

  let storedValue = localStorage.getItem("ScrapProcessID");
  let autoIncrementVal = "";
  let newProcessIDNum = "";

  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');
    return `${year}_${month}_${day}_${hours}_${minutes}_${seconds}`;
  }

  const getCSRFToken = async () => {
    var resTokenApiVal = auth.userData.access_token;
    console.log("acceesToken: " + resTokenApiVal);
    console.log("ConfigFileServerAPI URL: " + configJsonFile.ServerAPIUrl);
    await axios.get(configJsonFile.ServerAPIUrl, {
      headers: {
        'Content-Type': 'application/json',
        'x-api-id': configJsonFile.ClientId,
        'Authorization': "Bearer " + resTokenApiVal
      }
    }).then(res => {
      console.log(res);
      csrfToken.current = res.data.requestToken;
      cookieToken.current = res.data.cookieToken;
      //setCSRFToken(res.data.requestToken);
      //setCookieToken(res.data.cookieToken);
    })

  }

  // Form submit 
  const handleSubmit = async (event) => {

    //Checking at least one general information row;
    if (validator.isEmail(VendorEmail)) {
      if (rowsData.length >= 1) {
        const isSubmitConfirm = window.confirm('Are you sure you want to submit this request?');
        if (isSubmitConfirm) {
          event.preventDefault();
          setLoading(true);
          var CurrentYear = getCurrentDateTime();
          if (storedValue == null) {
            storedValue = 1;
          }

          // console.log("Auth User data Token: "+auth.userData.access_token);      
          var resTokenApiVal = auth.userData.access_token;
          // Call API Start
          newProcessIDNum = Number(storedValue) + 1;
          if (storedValue === 1) {
            autoIncrementVal = String(storedValue).padStart(3, 0);
          }
          else {
            autoIncrementVal = String(newProcessIDNum).padStart(3, 0);
          }
          const requestId = selectedFile.length;
          // Create JSON File
          var data = {
            ProcessInfo: {
              domainId: "supplyMangnt",
              ProcessId: configJsonFile.NewScrapProcessId,
              NewRequest: true,
              InstanceNumber: "",
              AttachmentID: "Att_" + configJsonFile.NewScrapProcessId + "_" + CurrentYear + "_" + autoIncrementVal + "_" + requestId,
              PathID: configJsonFile.NewScrapPathID,
              workflowID: configJsonFile.ScrapGuids.WorkflowGuid,
              businessEntity: configJsonFile.ScrapGuids.BusinessEntityGuid,
              dbId: configJsonFile.ScrapGuids.dbId,
              formTypeId: configJsonFile.ScrapGuids.formTypeId,
              BaseBPSPortalAddress: configJsonFile.BaseBPSPortalAddress,
              WebconClientId: configJsonFile.WebconClientId,
              WebconclientSecret: configJsonFile.WebconclientSecret,
              WebconTokenURL: configJsonFile.WebconTokenURL
            },
            Form: [
              { GUID: configJsonFile.ScrapGuids.VendorCodeFromReact, sValue: VendorCode, name: "Vendor Code from react" },
              { GUID: configJsonFile.ScrapGuids.VendorNameFromReact, sValue: VendorName, name: "Vendor Name from react" },
              { GUID: configJsonFile.ScrapGuids.VendorEmail, sValue: VendorEmail, name: "VendorEmail" },
              { GUID: configJsonFile.ScrapGuids.ContactName, sValue: ContactName, name: "ContactName" },
              { GUID: configJsonFile.ScrapGuids.Telephone, sValue: Telephone, name: "Telephone" },
              { GUID: configJsonFile.ScrapGuids.QualityManager, sValue: QualityManager, name: "QualityManager" },
              { GUID: configJsonFile.ScrapGuids.PWC_Representative, sValue: PWC_Representative, name: "PWC_Representative" },
              { GUID: configJsonFile.ScrapGuids.comments, sValue: comments, name: "comments" },
              { GUID: configJsonFile.ScrapGuids.isMutilationChecked, sValue: isChecked ? "true" : "false", name: "is Mutilation Checked" },
              { GUID: configJsonFile.ScrapGuids.InitiatorEmailAddress, sValue: InitiatorEmailAddress, name: "Initiator Eamil Address" },
              { GUID: configJsonFile.ScrapGuids.VendorEmail_Cc, sValue: VendorEmailCc, name: "VendorEmail_Cc" },
              { GUID: configJsonFile.ScrapGuids.SupplierInternalScrapGuid, sValue: SupplierInternalScrap, name: "Supplier Internal Scrap#" },
              { GUID: configJsonFile.ScrapGuids.ValueAddedGuid, sValue: ValueAdded, name: "Value Added" }
            ],
            GeneralInformation: rowsData,
            GeneralInformationListGuids: {
              PartNumberGuid: configJsonFile.ScrapGuids.partNumber,
              ReasonForScrapGuid: configJsonFile.ScrapGuids.ReasonForScrap,
              QuantityGuid: configJsonFile.ScrapGuids.Quantity,
              PO_SA_NumberGuid: configJsonFile.ScrapGuids.PO_SA_Number,
              QN_RFA_NumberGuid: configJsonFile.ScrapGuids.QN_RFA_Number,
              SerialNumberGuid: configJsonFile.ScrapGuids.SerialNumber,
              generalInfoItemListGuid: configJsonFile.ScrapGuids.GeneralInformationListGuid
            }
          };
          //alert(dictstring);
          console.log(data);
          CallWebAPI(data, resTokenApiVal);

          // Update Session variable to get increment num
          localStorage.setItem("ScrapProcessID", newProcessIDNum);
          // Call API End 
        }
      } else {
        alert("Please Add at least one Part Number under General Information Section!");
        event.preventDefault();
      }
    }
    else {
      alert("Please enter valid email address!");
      event.preventDefault();
    }
  }

  // Call API to upload files to S3
  const CallWebAPI = async (requestBody, getTokeVal) => {
    try {
      console.log("Attempting to call API to create/update webcon instance!..");
      const parsedUrl = new URL(configJsonFile.Server_Webcon_Creation_APIUrl);
      if (!isValidDomain(parsedUrl.hostname)) {
        throw new Error('Invalid domain');
      }
      const axiosInstance = axios.create({
              baseURL: configJsonFile.ServerAPIUrl,
              allowAbsoluteUrls: false
              });
      axios.post(parsedUrl, requestBody, {
        headers: {
          'Content-Type': 'application/json',
          'x-api-id': configJsonFile.ClientId,
          'Authorization': "Bearer " + getTokeVal,
          'RequestVerificationToken': csrfToken.current
        }
      }).then(res => {
        if (res.status === 201 || res.status === 200 || res.status === 202) {
          var elementID = res.data;
          if (selectedFile.length > 0) {
            for (let i = 0; i < selectedFile.length; i++) {
              // upload each file to S3 calling API here
              let Num = i + 1;
              CallWebAPIUploadFileToS3(selectedFile[i], Num, getTokeVal, elementID);
            }
          }else{
            setLoading(false);
            setmodelPopupshow(true);          
            setApiErrormessage("");
          }          
        } else {
          console.log("Status Code:" + res.status);
          console.log("Status Data:" + res.data);
        }
      }).catch(error => {
        if (error.response) {
          console.log('Error response:', error.response.data);
          setLoading(false);
          setApiErrormessage(error.response.data || 'An error occurred');
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }
      });
      console.log("... Attempt completed!");
    } catch (err) {
      console.log(err);    
      setAPIMessage("Failed Due to:" + err);
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

  }

  const CallWebAPIUploadFileToS3 = async (requestBody, num, getTokeVal, elementID) => {
    try {
      let FileNameWithoutSpace = requestBody.name.replaceAll(" ", "");
      let fileNameVal = elementID + "_" + num + "-" + FileNameWithoutSpace;
      console.log("FileName: " + fileNameVal);
      const formData = new FormData();
      formData.append('file', requestBody);
      formData.append('fileName', fileNameVal);
      formData.append('processID', "");
      formData.append('cookie', cookieToken.current);

      axios.post(configJsonFile.Server_Upload_FilesToS3_APIUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-api-id': configJsonFile.ClientId,
          'Authorization': "Bearer " +getTokeVal,
          'RequestVerificationToken': csrfToken.current        
        }
      }).then(res => {
        if (res.status === 201 || res.status === 200 || res.status === 202) {
          setLoading(false);
          setmodelPopupshow(true);          
          setApiErrormessage("");
          setAPIMessage("Files are uploaded successfully to AWS S3");
        } else {
          console.log("Status Code:" + res.status);
        }
      });
    } catch (err) {
      setLoading(false);
      setApiErrormessage(err.response.data || 'An error occurred');
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

  }

  const isValidDomain = (domain) => {
    const allowedDomains = ['apid.pwc.ca', 'apiq-ext.pwc.ca', 'api-ext.pwc.ca'];
    return allowedDomains.includes(domain);
  };
  const onClickHomeHandler = async (event) => {
    const isConfirmedHome = window.confirm('You might loose the data, Are you sure you want to go to home page?');
    if (isConfirmedHome) {
      navigate('/');
    }
  }
  const onClickCancelHandler = async (event) => {
    const isConfirmedCancel = window.confirm('You might loose the data, Are you sure you want to Cancel this request?');
    if (isConfirmedCancel) {
      navigate('/');
    }

  }

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  }
  // const autoCloseModelPopupOnTimeout=()=>{
  //   // 10 seconds time out automatically close the model-popup and redirect to home page.
  //   setTimeout(function()
  //   {
  //     navigate('/');
  //   }, 10000);
  // }
  const handleOkButtonModelPopup = () => {
    navigate('/');
    setmodelPopupshow(false);
  }

  const handleChangeConfirmCheckbox = () => {
    setIsConfirmChecked(!isConfirmChecked);
  }

  const validateInitiatorEmail = (e) => {
    const email = e.target.value;
    if (validator.isEmail(email)) {
      setInitiatorEmailAddress(e.target.value);
      setInitiatorEmailError("");
    } else {
      setInitiatorEmailAddress(e.target.value);
      setInitiatorEmailError("Please enter valid email id.");
    }
  }
  const validateVendorEmail = (e) => {
    const vEmail = e.target.value;
    if (validator.isEmail(vEmail)) {
      setVendorEmail(e.target.value)
      setVendorEmailError("");
    } else {
      setVendorEmail(e.target.value)
      setVendorEmailError("Please enter valid email id");
    }
  }
  const validateVendorEmailCc = (e) => {
    const vEmail = e.target.value;
    if (validator.isEmail(vEmail)) {
      setVendorEmailCc(e.target.value)
      setVendorEmailCcError("");
    } else {
      setVendorEmailCc(e.target.value)
      setVendorEmailCcError("Please enter valid email id");
    }
  }

  if (auth && auth.userData) {
    return (

      <form onSubmit={handleSubmit}>

        <div class="container">
          <div class="row">
            <div class="col-8 p-0">
              <img src={imgLogo} alt="Logo" width="100%" height="80%" />
            </div>
            <div class="col-4 p-0">
              <img src={rightLogo} alt="Logo" width="100%" height="80%" />
            </div>
          </div>
          <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">Vendor Information</h5></div></div>
          <div class="marginLeft" Id="InitialFields">
            <div class="row"><label style={{ color: 'red' }}>{apiErrormessage}</label> </div>
            <div class="row">
              <div class="col-2">
                <label for="InitiatorEmailAddress">Initiator User ID<label style={{ color: 'red' }}>*</label></label>
              </div>
              <div class="col-4">
                <input type="text"
                  value={InitiatorEmailAddress}
                  onChange={(e) => setInitiatorEmailAddress(e.target.value)}
                  placeholder="Enter Initiator User ID" required />
              </div>
              <div class="col-2">
                <label for="vendorEmail">Vendor Email<label style={{ color: 'red' }}>*</label></label>
              </div>
              <div class="col-4">
                <input type="text"
                  value={VendorEmail}
                  onChange={(e) => validateVendorEmail(e)}
                  placeholder="Enter Vendor Email" required />
                <div style={{ color: 'red' }}>{vendorEmailError}</div>
              </div>
            </div>

            <div class="row">
              <div class="col-2">
                <label for="vendorCode">Vendor Code<label style={{ color: 'red' }}>*</label></label>
              </div>
              <div class="col-4">
                <input type="number"
                  value={VendorCode}
                  onChange={(e) => setVendorCode(e.target.value)}
                  placeholder="Enter Vendor Code" required />
              </div>
              <div class="col-2">
                <label for="vendorName">Vendor Name<label style={{ color: 'red' }}>*</label></label>
              </div>
              <div class="col-4">
                <input type="text"
                  value={VendorName}
                  onChange={(e) => setVendorName(e.target.value)}
                  placeholder="Enter Vendor Name" required />
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <label for="vendorEmail(cc)">Vendor Email (cc)</label>
              </div>
              <div class="col-4">
                <input type="text"
                  value={VendorEmailCc}
                  onChange={(e) => validateVendorEmailCc(e)}
                  placeholder="Enter Vendor Email (cc)" />
                <div style={{ color: 'red' }}>{vendorEmailCcError}</div>
              </div>
              <div class="col-2">
                <label for="ContactName">Vendor Contact Name<label style={{ color: 'red' }}>*</label></label>
              </div>
              <div class="col-4">
                <input type="text"
                  value={ContactName}
                  onChange={(e) => setContactName(e.target.value)}
                  placeholder="Enter Contact Name" required />
              </div>
            </div>

            <div class="row">
              <div class="col-2">
                <label for="Telephone">Telephone</label>
              </div>
              <div class="col-4">
                <input type="text"
                  value={Telephone}
                  onChange={(e) => setTelephone(e.target.value)}
                  placeholder="Enter Phone Number" />
              </div>
              <div class="col-2">
                <label for="Date">Date</label>
              </div>
              <div class="col-4">
                <input type="Date"
                  value={DateValue}
                  onChange={(e) => setDateValue(e.target.value)}
                  placeholder="Enter Date" required readOnly style={{ backgroundColor: '#e9ecefe3' }} />
              </div>
            </div>

            <div class="row">
              <div class="col-2">
                <label for="PWC_Representative">P&WC Representative(DQR, SQAR or TPSI)</label>
              </div>
              <div class="col-4">
                <input type="text"
                  value={PWC_Representative}
                  onChange={(e) => setPWC_Representative(e.target.value)}
                  placeholder="Enter P&WC representative" />
              </div>
              <div class="col-2">
                <label for="QualityManager">Quality Manager at Supplier</label>
              </div>
              <div class="col-4">
                <input type="text"
                  value={QualityManager}
                  onChange={(e) => setQualityManager(e.target.value)}
                  placeholder="Enter Quality Manager" />
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <label for="ValueAdded">
                  <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    Value Added
                    <span style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '22px',
                      height: '22px',
                      borderRadius: '50%',
                      background: '#e9ecef',
                      color: '#007bff',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                      border: '1px solid #007bff',
                      fontSize: '16px',
                      verticalAlign: 'middle',
                      marginLeft: '8px',
                      position: 'relative',
                      boxSizing: 'border-box',
                      userSelect: 'none'
                    }}
                      title="Supplier should add a document in attachment section"
                    >i</span>
                  </span></label>
              </div>
              <div class="col-4">
                <input type="number"
                  value={ValueAdded}
                  onChange={(e) => setValueAdded(e.target.value)}
                  placeholder="Enter Value Added" />
              </div>
              <div class="col-2" style={{ paddingLeft: '0px'}}>
                <label for="SupplierInternalScrap">Supplier Internal Scrap#</label>
              </div>
              <div class="col-4">
                <input type="text"
                  value={SupplierInternalScrap}
                  onChange={(e) => setSupplierInternalScrap(e.target.value)}
                  placeholder="Enter Internal Scrap#" />
              </div>
            </div>

            <div class="row">
                <div class="col-11" style={{ display: 'flex', alignItems: 'center' }}>
                  <label htmlFor="Is it already mutilated?" style={{ marginBottom: 0 }}>Check the box if the part(s) have already been mutilated</label>
                  &nbsp;&nbsp;
                  <input type="checkbox"
                    value={isChecked}
                    onChange={handleCheckboxChange}
                    style={{ marginRight: '8px' }}
                  />                  
                </div>
              </div>

          </div>

          <GeneralInformationTable rowsData={rowsData} setRowsData={setRowsData} />

          <br/>
          <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">Comments</h5></div></div>          
          <div class="row">           
            <div class="col-12">
              <textarea class="VendorComments" id="Comments" name="Comments" value={comments} placeholder="Write something.." onChange={(e) => setComments(e.target.value)} ></textarea>
            </div>
          </div>
          
          <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">Attachments</h5></div></div>
          <div class="marginLeft" Id="attachments">
          <div class="row"> <div class="GeneralInfoNote"><b>Accepted file types - png, jpeg, pdf, xlsx, pptx and docx only</b></div></div>
          <div class="row">           
            <div class="col-10">
              <input type="file" onChange={(e) => setSelectedFile(e.target.files ? e.target.files : null)} multiple />
            </div>
          </div>
          </div>
          <br/>

          <div class="row">
            <div>
              <input type="checkbox" value={isConfirmChecked} style={{ color: 'red' }} onChange={handleChangeConfirmCheckbox} required />&nbsp;&nbsp; <label style={{ color: 'red' }}>I confirm this form and attached document(s) DO NOT contain any technical information subject to EAR, ITAR or ECL</label>
            </div>
          </div>

          <div class="row">
            <div class="col-4">
              <input type="submit" value="Submit" /> &nbsp;
              <input type="button" value="Home" onClick={onClickHomeHandler} /> &nbsp;
              <input type="button" value="Cancel" onClick={onClickCancelHandler} />
            </div>
          </div>
          <div class="row">
            <div class="col-10 text-success">
              <Modal
                show={modelPopupshow}
                onHide={handleOkButtonModelPopup}
                backdrop="static"
                keyboard={false}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Header style={{ backgroundColor: '#1f2a44', color: 'white' }}>
                  <Modal.Title> Scrap Evaluation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p> Your Scrap Evaluation request has been submitted.</p>
                  <p> You will receive an email with the request information and details for tracking purposes.</p>
                  <p> Please reach out to your buyer in case of any issues or concerns regarding your request.</p>
                  <p> Click <strong><mark>OK</mark></strong> to return to the home page.</p>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleOkButtonModelPopup}>
                    OK
                  </Button>
                </Modal.Footer>
              </Modal>
              <Modal
                show={loading}
                onHide={handleOkButtonModelPopup}
                backdrop="static"
                keyboard={false}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Header style={{ backgroundColor: '#1f2a44', color: 'white' }}>
                  <Modal.Title> Request in-progress, please wait...</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p>Loading....</p>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
      </form>
    )
  } else {
    return <div>Not logged in! Try to refresh to be redirected to login page.</div>;
  }
}

export default NewScrapEvaluation;
